export enum SegmentNameEnum {
  'sidebar' = 'People - Menu - Page View',
  '/new' = 'People - Active Collaborator Send Spreadsheet - Page View',
  '/all' = 'People - Active Collaborator Listing - Page View',
  '/profile' = 'People - Active Collaborator Profile - Page View',
  '/signatures' = 'Viewed People - Collaborator Profile - Signatures Page View Page'
}

export enum SegmentTitlePage {
  '/all' = 'Listagem Colaboradores',
  '/new' = 'Importação de Colaboradores',
  '/profile' = 'Perfil do Colaborador',
  '/signatures' = 'Collaborator Profile Signatures'

}

export enum SegmentEventName {
  'open_sidebar' = 'People - Menu - Page View',
  'click_link_employee_app' = 'People - Menu - Collaborator',
  'listing_empty' = 'People - Active Collaborator Import - Page View',
  'listing_export_button' = 'People - Active Collaborator Listing - Export Contributors',
  'listing_import_button' = 'People - Active Collaborator Listing - Import Collaborators',
  'import_download_speadsheet' = 'People - Active Collaborator Send Spreadsheet - Model Spreadsheet',
  'import_send_speadsheet' = 'People - Active Collaborator Send Spreadsheet - Send Spreadsheet',
  'import_format_invalid' = 'People - Active Collaborator Error - Page View',
  'import_preview' = 'People - Preview table - Page View',
  'import_save' = 'People - Active Collaborator Preview table - Save',
  'export_listing' = 'People - Active Collaborator Listing - Modal View',
  'export_listing_save' = 'People - Active Collaborator Listing - Export Collaborators Modal View',
  'export_listing_error' = 'People - Active Collaborator Listing - Error Modal View',
  'profile_active' = 'People - Active Collaborator Profile - Active User',
  'profile_export' = 'People - Active Collaborator Profile - Export'
}
